import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
	fetchMatterDetail,
	closeMatter,
	setEditMatterRedirectLocation,
	setMatterLifecycleStatus,
} from "../actions/matterActions";
import {
	NORMAL_LIFECYCLE_STATUS,
	TRASH_LIFECYCLE_STATUS,
	ARCHIVE_LIFECYCLE_STATUS,
	getDisabledStateFromLifecycleStatuses,
} from "../utilities/lifecycleStatus";
import { selectArchiveMattersAccess } from "../utilities/archiveAccess";
import { unselectAll } from "../actions/multiselectActions";
import { listDirectory } from "../actions/documentActions";
import { setCreatableContext } from "../actions/navigateActions";

import { DropDownButtonWithRouter } from "./DropDownButton";
import DocumentList from "./DocumentList";
import { tabUrlMap } from "./DocumentListUtils";
import TextGrid from "./TextGrid";
import MaterialTabs from "./MaterialTabs";
import {
	encodeFullpath,
	decodeFullpath,
	shortDateFormatOffset,
} from "../utilities/utilities";
import MaximumItemsList from "./MaximumItemsList";

import { withRouter } from "../utilities/withRouter";
import cliofavicon from "../images/clio-favicon.png";
import { toggleMatterInfo } from "../actions/browserLocalstorageActions";
import { openGlobalDialog } from "../actions/globalEditDialogActions";
import ButtonLink from "./ButtonLink";

import { ExternalSharingManagementForMatter } from "./ExternalSharingManagement";
import MatterAiPane from "./MatterAi/MatterAiPane";
import ArchiveAndTrashList from "./ArchiveAndTrashList";
import {
	TrashBinMessage,
	AbbreviatedDocumentListDataMessage,
} from "./Utils/UnderSubHeaderWarningMessages";
import {
	IconArchive,
	IconFile,
	IconMail,
	IconNote,
	IconShare2,
	IconSparkles,
	IconTrash,
} from "@tabler/icons-react";

const basepathnameMap = {
	docs: "Documents",
	email: "Email",
	notes: "Notes",
	sharing: "Sharing",
	archive: "Archive",
	trash: "Trash",
};
const tabMap = [
	{
		label: (
			<span style={{ display: "flex", alignItems: "center" }}>
				<IconFile style={{ verticalAlign: "sub", marginRight: 8 }} />
				Documents
			</span>
		),
		url: "docs",
	},
	{
		label: (
			<span style={{ display: "flex", alignItems: "center" }}>
				<IconMail style={{ verticalAlign: "sub", marginRight: 8 }} />
				Email
			</span>
		),
		url: "email",
	},
	{
		label: (
			<span style={{ display: "flex", alignItems: "center" }}>
				<IconNote style={{ verticalAlign: "sub", marginRight: 8 }} />
				Notes
			</span>
		),
		url: "notes",
	},
	{
		label: (
			<span style={{ display: "flex", alignItems: "center" }}>
				<IconSparkles
					style={{ verticalAlign: "sub", marginRight: 8 }}
					fill={"currentColor"}
				/>
				AI
			</span>
		),
		url: "ai",
	},
	{
		label: (
			<span style={{ display: "flex", alignItems: "center" }}>
				<IconShare2 style={{ verticalAlign: "sub", marginRight: 8 }} />
				Sharing
			</span>
		),
		url: "sharing",
	},
	{
		label: (
			<span style={{ display: "flex", alignItems: "center" }}>
				<IconArchive style={{ verticalAlign: "sub" }} />
			</span>
		),
		url: "archive",
		hoverTitle: "Archive",
		rightJustified: true,
	},
	{
		label: (
			<span style={{ display: "flex", alignItems: "center" }}>
				<IconTrash style={{ verticalAlign: "sub" }} />
			</span>
		),
		url: "trash",
		hoverTitle: "Trash Bin",
		rightJustified: true,
	},
];

const DocumentListWithRouter = withRouter(DocumentList);
class MatterDetail extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			s3Basepath: "",
			descriptionOverflowing: false,
			lastLocation: {
				docs: "docs/",
				email: "email/",
				notes: "notes/",
				sharing: "sharing/",
				ai: "ai/",
				archive: "archive/docs",
				trash: "trash/docs",
			},
		};
		this.descriptionRef = React.createRef();
		this.getAPIBasepath = this.getAPIBasepath.bind(this);
		this.switchedTab = this.switchedTab.bind(this);
		this.makeEditMenu = this.makeEditMenu.bind(this);
		this.refresh = this.refresh.bind(this);
	}
	getUrlPrefix() {
		return (
			"/matters/" +
			this.props.match.params.id +
			"/" +
			this.props.match.params.root +
			"/"
		);
	}
	getAPIBasepath() {
		return (
			this.props.match.params.root +
			"/" +
			(decodeFullpath(this.props.match.params.fullpath) || "")
		);
	}

	switchedTab(value) {
		const newURL =
			"/matters/" +
			this.props.match.params.id +
			"/" +
			this.state.lastLocation[tabMap[value].url];
		this.props.history.push(newURL);
	}
	//Open in ClioMatter
	setClioMatterID() {
		return `https://app.clio.com/nc/#/matters/${this.props.matterDetails.clioMatterID}`;
	}
	refresh(includeMatterDetails) {
		const activeTab = this.props.match.params.root;
		if (
			activeTab === "sharing" ||
			activeTab === "ai" ||
			activeTab === "trash" ||
			activeTab === "archive"
		) {
			this.props.fetchMatterDetail(this.props.match.params.id);
		} else {
			//docs, email, or notes
			this.props.listDirectory(
				this.props.match.params.id,
				this.getAPIBasepath(),
				this.props.match.params.root,
				includeMatterDetails
			);
			this.props.setCreatableContext(true);
			this.props.unselectAll();
			var table = document.querySelector(".rt-tbody");
			if (table) {
				document.querySelector(".rt-tbody").scrollTop = 0;
			}
		}
	}
	componentDidMount() {
		this.refresh(true);
	}
	componentWillUnmount() {
		this.props.setCreatableContext(false);
	}
	static getDerivedStateFromProps(props, state) {
		var lastLocation = { ...state.lastLocation };
		const root = props.match.params.root;
		if (root === "archive" || root === "trash") {
			lastLocation[root] = `${root}/${props.match.params.context}`;
		} else {
			lastLocation[root] = encodeFullpath(
				root + "/" + (props.match.params.fullpath || "")
			);
		}
		return { ...state, lastLocation };
	}
	checkDescriptionOverflow() {
		const el = this.descriptionRef.current;
		const desc = this.props.matterDetails.description;
		const isOverflowing =
			(el && el.scrollWidth > el.clientWidth) ||
			(desc && desc.includes("\n"));
		if (isOverflowing !== this.state.descriptionOverflowing) {
			this.setState({ descriptionOverflowing: isOverflowing });
		}
	}
	componentDidUpdate(prevProps) {
		if (
			prevProps.match.params.fullpath !==
				this.props.match.params.fullpath ||
			prevProps.match.params.root !== this.props.match.params.root ||
			prevProps.match.params.id !== this.props.match.params.id
		) {
			// setTimeout(0) defers the API call outside of flushSync's synchronous
			// render cycle — async operations (e.g. fetchAuthSession) hang when
			// started during flushSync in React 18 createRoot.
			setTimeout(() => this.refresh(false), 0);
		}
		if (prevProps.match.params.id !== this.props.match.params.id) {
			setTimeout(() => this.refresh(true), 0);
		}
		if (
			prevProps.matterDetails.description !==
			this.props.matterDetails.description
		) {
			this.checkDescriptionOverflow();
		}
	}
	makeEditMenu() {
		const postEditLocation = `/matters/${this.props.match.params.id}/docs`;
		var menu = [
			{
				text: "Edit Matter Info",
				href: "/matters/" + this.props.match.params.id + "/edit/",
				selectCallback: () =>
					this.props.setEditMatterRedirectLocation(postEditLocation),
			},
		];
		if (this.props.userRights.UPDATE_MATTER_PERMISSIONS) {
			menu.push({
				text: "Edit Matter Permissions",
				href:
					"/matters/" +
					this.props.match.params.id +
					"/edit/permissions",
				selectCallback: () =>
					this.props.setEditMatterRedirectLocation(postEditLocation),
			});
		}

		// refresh already knows which tabs list a directory and which only need the matter details
		const matterCallbackAfterStatusChange = () => this.refresh(true);
		const previousMatterLifecycleStatus =
			this.props.matterDetails.matterLifecycleStatus;

		if (this.props.matterLifecycleStatusObject.IN_ARCHIVE) {
			const access = this.props.archiveMattersAccess.unarchive;
			menu.push({
				text: "Unarchive Matter",
				disabled: access.disabled,
				disabledHoverText: access.disabled ? access.disabledText : "",
				onSelect: () =>
					this.props.setMatterLifecycleStatus({
						matterLifecycleStatus: NORMAL_LIFECYCLE_STATUS,
						previousMatterLifecycleStatus,
						matterID: this.props.match.params.id,
						callback: matterCallbackAfterStatusChange,
					}),
			});
		} else {
			const access = this.props.archiveMattersAccess.archive;
			menu.push({
				text: "Archive Matter",
				disabled: access.disabled,
				disabledHoverText: access.disabled ? access.disabledText : "",
				onSelect: () =>
					this.props.setMatterLifecycleStatus({
						matterLifecycleStatus: ARCHIVE_LIFECYCLE_STATUS,
						previousMatterLifecycleStatus,
						matterID: this.props.match.params.id,
						callback: matterCallbackAfterStatusChange,
					}),
			});
		}

		if (this.props.matterLifecycleStatusObject.IN_TRASH) {
			menu.push({
				text: "Restore Matter from Trash Bin",
				onSelect: () =>
					this.props.setMatterLifecycleStatus({
						matterLifecycleStatus: NORMAL_LIFECYCLE_STATUS,
						previousMatterLifecycleStatus,
						matterID: this.props.match.params.id,
						callback: matterCallbackAfterStatusChange,
					}),
			});
		} else {
			const trashFromArchiveAccess = this.props
				.matterLifecycleStatusObject.IN_ARCHIVE
				? this.props.archiveMattersAccess.unarchive
				: null;
			menu.push({
				text: "Move Matter to Trash Bin",
				disabled: trashFromArchiveAccess?.disabled,
				disabledHoverText: trashFromArchiveAccess?.disabled
					? trashFromArchiveAccess.disabledText
					: "",
				onSelect: () =>
					this.props.setMatterLifecycleStatus({
						matterLifecycleStatus: TRASH_LIFECYCLE_STATUS,
						previousMatterLifecycleStatus,
						matterID: this.props.match.params.id,
						callback: matterCallbackAfterStatusChange,
					}),
			});
		}

		menu.push(
			!this.props.matterDetails.dateClosed
				? {
						text: "Close Matter",
						onSelect: () =>
							this.props.closeMatter(
								this.props.match.params.id,
								false
							),
						disabled:
							this.props.matterLifecycleStatusObject.disabled,
					}
				: {
						text: "Reopen Matter",
						onSelect: () =>
							this.props.closeMatter(
								this.props.match.params.id,
								true
							),
						disabled:
							this.props.matterLifecycleStatusObject.disabled,
					}
		);

		return menu;
	}

	render() {
		return (
			<div className="fullHeightFlex noDefaultMargin">
				{this.props.matterLifecycleStatusObject.disabled
					? TrashBinMessage({
							objectType: "Matter",
							itemLocation:
								this.props.matterLifecycleStatusObject
									.itemLocation,
							deniedOperationsArray: [
								"edit",
								"open",
								"save",
								"upload documents to",
							],
						})
					: null}
				{this.props.documentListDataColumnsAreAbbreviated ? (
					<AbbreviatedDocumentListDataMessage />
				) : null}
				<div
					className="clientInfoHeader"
					style={{
						position: "relative",
						minHeight: 48,
						padding: 24,
						display: this.props.matterInfoHidden ? "none" : "block",
					}}
				>
					<div
						style={{
							display: "grid",
							gridTemplateColumns: "4fr 2fr",
						}}
					>
						<div>
							<TextGrid
								numColumns={2}
								columns={[
									[
										"Client",
										this.props.matterDetails.clientName
											? {
													href: `/clients/${this.props.matterDetails.clientID}`,
													text: this.props
														.matterDetails
														.clientName,
												}
											: "-",
									],
									[
										"Custom Matter ID",
										this.props.matterDetails
											.customMatterID || "-",
									],
								]}
							/>

							<TextGrid
								numColumns={2}
								columns={[
									[
										"Matter Type",
										this.props.matterDetails.matterType,
									],
									[
										"Location",
										this.props.matterDetails.officeBranch ||
											"-",
									],
								]}
							/>
							<TextGrid
								numColumns={2}
								columns={[
									[
										"Date Opened",
										this.props.matterDetails.dateOpened
											? shortDateFormatOffset(
													this.props.matterDetails
														.dateOpened
												)
											: "-",
									],

									[
										"Date Closed",
										this.props.matterDetails.dateClosed
											? shortDateFormatOffset(
													this.props.matterDetails
														.dateClosed
												)
											: "-",
									],
								]}
							/>
							<TextGrid
								numColumns={2}
								columns={[
									[
										"Description",
										this.props.matterDetails.description ? (
											<div>
												<div
													ref={this.descriptionRef}
													style={{
														whiteSpace: "nowrap",
														overflow: "hidden",
														textOverflow:
															"ellipsis",
														maxWidth: "15vw",
													}}
												>
													{
														this.props.matterDetails.description.split(
															"\n"
														)[0]
													}
												</div>
												{this.state
													.descriptionOverflowing && (
													<ButtonLink
														onClick={() =>
															this.props.openGlobalDialog(
																{
																	label: "Description",
																	mainText:
																		this
																			.props
																			.matterDetails
																			.description,
																	canSubmit: true,
																	hideTextfield: true,
																	readOnly: true,
																	cancelButtonLabel:
																		"Ok",
																},
																null,
																() => ({
																	canSubmit: true,
																})
															)
														}
													>
														See All...
													</ButtonLink>
												)}
											</div>
										) : (
											""
										),
									],
								]}
							/>
							{this.props.matterDetails.clioMatterID ? (
								<TextGrid
									numColumns={1}
									columns={[
										[
											<div
												style={{
													paddingTop: 10,
												}}
												key="clioLink"
											>
												<a
													target="_blank"
													rel="noopener noreferrer"
													href={this.setClioMatterID()}
												>
													<img
														alt="someImage"
														align="center"
														src={cliofavicon}
														className="legalworks-clio-logo"
													/>
													Open in Clio Manage
												</a>
											</div>,
										],
									]}
								/>
							) : null}
						</div>
						<div>
							<TextGrid
								numColumns={1}
								columns={[
									[
										"Assigned Staff",
										<MaximumItemsList
											maxItems={5}
											key="AssignedStaff"
											items={
												this.props.matterDetails
													.assignedStaff
													? this.props.matterDetails.assignedStaff.map(
															(x) => x.displayName
														)
													: []
											}
										/>,
									],
								]}
							/>
						</div>
					</div>
					<div style={{ position: "absolute", top: 16, right: 16 }}>
						<DropDownButtonWithRouter
							title="Edit"
							pullRight
							menuItems={this.makeEditMenu()}
						/>
					</div>
				</div>
				<MaterialTabs
					activeTab={
						tabUrlMap[this.props.match.params.root + "/"].index
					}
					tabs={tabMap}
					switchedTab={this.switchedTab}
					toggleHide={this.props.toggleMatterInfo}
					hidden={this.props.matterInfoHidden}
				/>
				{this.props.match.params.root === "sharing" ? (
					<ExternalSharingManagementForMatter
						matterIDFilter={this.props.match.params.id}
						matterLifecycleStatus={this.props.matterLifecycleStatus}
					/>
				) : this.props.match.params.root === "ai" ? (
					<MatterAiPane
						matterID={this.props.match.params.id}
						sessionId={this.props.match.params.fullpath}
					/>
				) : this.props.match.params.root === "archive" ||
				  this.props.match.params.root === "trash" ? (
					<ArchiveAndTrashList root={this.props.match.params.root} />
				) : (
					<DocumentListWithRouter
						urlPrefix={this.getUrlPrefix()}
						matterID={this.props.match.params.id}
						breadcrumbRootName={
							basepathnameMap[this.props.match.params.root]
						}
						root={this.props.match.params.root + "/"}
						apiBasepath={this.getAPIBasepath()}
						fullpath={this.props.match.params.fullpath}
						values={this.props.documentList}
						clioMatterID={this.props.matterDetails.clioMatterID}
						clioIntegrationSettingStatus={
							this.props.clioIntegrationSettingStatus
						}
						matterInfoVisible={!this.props.matterInfoHidden}
					/>
				)}
			</div>
		);
	}
}
MatterDetail.propTypes = {
	loading: PropTypes.bool.isRequired,
};
const mapStateToProps = (state) => ({
	matterDetails: state.matter.matterDetails,
	documentList: state.document.documentList,
	prefix: state.document.prefix,
	loading: state.matter.matterDetailsLoading,
	hasPermissionsAccess: state.user.hasPermissionsAccess,
	clioIntegrationSettingStatus: state.tenant.clioIntegrationSettingStatus,
	matterInfoHidden: state.browserLocalstorage.matterInfoHidden,
	matterLifecycleStatus: state.matter.matterDetails.matterLifecycleStatus,
	matterLifecycleStatusObject: getDisabledStateFromLifecycleStatuses({
		matterLifecycleStatus: state.matter.matterDetails.matterLifecycleStatus,
	}),
	documentListDataColumnsAreAbbreviated:
		state.document.documentListDataColumnsAreAbbreviated,
	userRights: state.user.userRights,
	archiveMattersAccess: selectArchiveMattersAccess(state),
});
export default connect(mapStateToProps, {
	fetchMatterDetail,
	closeMatter,
	listDirectory,
	unselectAll,
	setCreatableContext,
	setEditMatterRedirectLocation,
	toggleMatterInfo,
	setMatterLifecycleStatus,
	openGlobalDialog,
})(MatterDetail);
